module.exports = __webpack_public_path__ + "img/out_icon.9192f065.png";